

var __assign = (this && this.__assign) || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (const p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) { t[p] = s[p]; }
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, '__esModule', { value: true });
exports.native = void 0;
const native = /** @class */ (function () {
  function native(runtimeName) {
    this.name = runtimeName;
    if (!window.jsBridge) {
      window.jsBridge = {
        hybrid: {
          registerHandler: function (res) {
            if (res.name === 'ready') {
              if (res.status === 1) {
                console.log({ status: 1, msg: '' });
              } else {
                alert('页面加载失败, 请重试...');
              }
            }
          },
        },
                // 设置一个空函数，因为在webview切换的时候，native会主动去调用这个函数，默认是空函数，如果需要做一些后续动作，在自己的需求上
                // 重新复写这个函数即可
        viewAppear: function () { }
      };
    } else {
      alert('挂载API出错!');
    }
    console.warn('current app run on the ', runtimeName);
  }
    /**
     * 点我达APP下无需任何配置，空函数
     * @description
     */
  native.prototype.config = function () {
  };

  native.prototype.callHandler = function (data) {
    const requestId = Math.random().toString().match(/0\.(.*)/)[1];
    let successCallbackName = '';
    let failCallBackName = '';
    if (data.onSuccess) {
      successCallbackName = `${data.name}Success_${requestId}`;
            /* 将onSuccess挂载到window.jsBridge下 */
      window.jsBridge[successCallbackName] = function () {
        const args = [];
        for (let _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        data.onSuccess.apply(data.onSuccess, args);
        delete window.jsBridge[successCallbackName];
      };
    }
    if (data.onFail) {
      failCallBackName = `${data.name}Fail_${requestId}`;
      window.jsBridge[failCallBackName] = function () {
        const args = [];
        for (let _i = 0; _i < arguments.length; _i++) {
          args[_i] = arguments[_i];
        }
        data.onFail.apply(data.onFail, args);
        delete window.jsBridge[failCallBackName];
      };
    }
    const newData = {
      name: data.name,
      params: data.params,
      onSuccess: `jsBridge.${successCallbackName}`,
      onFail: `jsBridge.${failCallBackName}`
    };
    if (window.webkit) {
      window.webkit.messageHandlers.callHandler.postMessage(newData);
    } else if (window.dianwoda && typeof window.dianwoda.callHandler === 'function') {
      window.dianwoda.callHandler(JSON.stringify(newData));
    }
  };

    /**
     * 在点我达APP下设置Title
     *
     * @param {Runtime.DwdTitleData} params
     */
  native.prototype.setHeader = function (params) {
    if (typeof params.title === 'undefined') {
      throw new Error('标题未定义');
    }
    let leftBtnFunName = '';
    if (params.leftBtn && params.leftBtn.onClick) {
            /* 将左边按钮的onClick挂载到window.jsBridge下 */
      window.jsBridge.setLeftBtnOnClick = params.leftBtn.onClick;
      leftBtnFunName = 'jsBridge.setLeftBtnOnClick';
    }
        /* 将右边按钮组的onClick挂载到window.jsBridge下 */
    const newParams = [];
    params.rightBtns && params.rightBtns.map((item, index) => {
      let rightBtnFunName = '';
      if (item.onClick) {
        window.jsBridge[`setRightBtnOnClick${index}`] = item.onClick;
        rightBtnFunName = `jsBridge.setRightBtnOnClick${index}`;
      }
      newParams.push({
        onClick: rightBtnFunName,
        text: item.text,
        color: item.color || '#fe751a',
        image: item.image,
        redIcon: item.redIcon || false
      });
    });
    this.callHandler({
      name: 'setHeaderTitle',
      params: { title: params.title },
    });
    this.callHandler({
      name: 'setLeftHeader',
      params: { button: { onClick: leftBtnFunName, data: params.data || null } }
    });
    this.callHandler({
      name: 'setRightHeader',
      params: { buttons: newParams }
    });
  };
    /**
     * 在点我达商家APP下跳转到订单详情页
     *
     * @param {Runtime.DwdGoToShopOrderData} params
     */
  native.prototype.gotoShopOrderDetail = function (params) {
    const _this = this;
    return new Promise((resolve, reject) => {
      _this.callHandler({
        name: 'gotoOrderDetail',
        params: { orderId: params.orderId },
        onSuccess: function (res) {
          resolve(res);
        },
        onFail: function (res) {
          reject(res.errMsg);
        }
      });
    });
  };

    /**
     * 在点我达骑手APP下提交追加单取消原因
     *
     * @param {Runtime.DwdAppendOrderCancelReason} params
     */
  native.prototype.submitAppendOrderCancelReason = function (params) {
    this.callHandler({
      name: 'nativeCommitAppendOrderCancelReason',
      params: params,
    });
  };

    /**
     * 在点我达APP下关闭掉H5页面
     *
     */
  native.prototype.closeWindow = function () {
    this.callHandler({
      name: 'close'
    });
  };
    /**
     * 在点我达APP下调用打电话
     *
     * @param {any} element
     */
  native.prototype.callPhone = function (params) {
    this.callHandler({
      name: 'call',
      params: params,
    });
  };
    /**
     * 在点我达APP下获取网络类型
     *
     */
  native.prototype.getNetworkType = function () {
    const _this = this;
    return new Promise((resolve, reject) => {
      _this.callHandler({
        name: 'getNetwork',
        onSuccess: function (res) {
          resolve(res.networkType);
        },
        onFail: function (res) {
          reject(res);
        }
      });
    });
  };
    /**
     * 在点我达APP下打开外部浏览器
     *
     * @param {Runtime.DwdOpenBrowserData} params
     */
  native.prototype.openExternalBrowser = function (params) {
    this.callHandler({
      name: 'openBrowser',
      params: params
    });
  };
    /**
     * 在点我达APP下复制到剪切板
     *
     * @param {Runtime.DwdCopyToClipData} params
     */
  native.prototype.copyToClipBoard = function (params) {
    this.callHandler({
      name: 'setClipboardData',
      params: params
    });
  };
    /**
     * 在点我达APP下从剪切板获取文本
     *
     */
  native.prototype.pasteFromClipBoard = function () {
    const _this = this;
    return new Promise((resolve, reject) => {
      _this.callHandler({
        name: 'getClipboardData',
        onSuccess: function (res) {
          resolve(res);
        },
        onFail: function (res) {
          reject(res);
        }
      });
    });
  };
    /**
     * 在点我达APP下暂停音频
     *
     * @param {any} element
     */
  native.prototype.pauseAudio = function (element) {
    element.pause();
        // 保证下次play的时候能够从头开始播放
    element.currentTime = 0;
  };

    /**
     * 在点我达APP下播放音频
     *
     * @param {any} element
     */
  native.prototype.playAudio = function (element) {
    element.play();
  };

    /**
     * 点我达APP下分享给朋友功能
     *
     * @param {Runtime.MessageShareData} params
     * @returns {Promise}
     */
  native.prototype.shareToFriends = function (params) {
    const _this = this;
    return new Promise((resolve, reject) => {
      _this.callHandler({
        name: 'shareToFriends',
        params: params,
        onSuccess: resolve,
        onFail: reject
      });
    });
  };

    /**
     * 点我达APP下的扫码功能，其实是返回者指环境下定的数据
     *
     * @param {Runtime.ScanQRCodeData} params
     * @returns {Promise}
     */
  native.prototype.scanQRCode = function (params) {
    const _this = this;
    return new Promise((resolve, reject) => {
      _this.callHandler({
        name: 'scanQRCode',
        onSuccess: resolve,
        onFail: reject
      });
    });
  };

    /**
     * 点我达APP下获取地理位置功能
     *
     * @param {Runtime.GetLocationParam} params
     * @returns {Promise}
     */
  native.prototype.getLocation = function (params) {
    const _this = this;
    return new Promise((resolve, reject) => {
      _this.callHandler({
        name: 'getLocation',
        onSuccess: function (res) {
          resolve(res);
        },
        onFail: function (res) {
          reject(res);
        }
      });
    });
  };

    /**
     * 点我达APP下打开地理位置功能
     *
     * @param {Runtime.LocationData} location
     * @returns {Promise}
     */
  native.prototype.openLocation = function (params) {
    return new Promise((resolve, reject) => resolve('打开地图成功'));
  };

    /**
     * 点我达APP下获取图片功能
     *
     * @param {Runtime.ChooseImageData} params
     * @returns {Promise}
     */
  native.prototype.chooseImage = function (params) {
    const _this = this;
    return new Promise((resolve, reject) => {
      _this.callHandler({
        name: 'chooseImage',
        params: params,
        onSuccess: resolve,
        onFail: reject
      });
    });
  };

    /**
     * 点我达APP下上传图片功能
     *
     * @param {Runtime.UploadResource} params
     * @returns {Promise}
     */
  native.prototype.uploadImage = function (params) {
    const _this = this;
    return new Promise((resolve, reject) => {
      _this.callHandler({
        name: 'uploadImage',
        params: params,
        onSuccess: resolve,
        onFail: reject
      });
    });
  };
    /**
     * 点我达APP打开一个对话框
     *
     * @param {Runtime.DwdDialogData} params
     */
  native.prototype.showDialog = function (params) {
    const buttons = params.buttons && params.buttons.map((item, index) => {
      let button = {};
      if (item.onClick) {
        window.jsBridge[`handleDialogButtonClick${index}`] = item.onClick;
        button = __assign(__assign({}, item), { onClick: `jsBridge.handleDialogButtonClick${index}` });
      } else {
        button = __assign(__assign({}, item), { onClick: '' });
      }
      return button;
    });
    let link;
    if (params.link) {
      if (params.link.onClick) {
        window.jsBridge.handleDialogLinkClick = params.link.onClick;
        link = __assign(__assign({}, params.link), { onClick: 'jsBridge.handleDialogLinkClick' });
      } else {
        link = __assign(__assign({}, params.link), { onClick: '' });
      }
    }
    this.callHandler({
      name: 'dialog',
      params: { title: params.title, message: params.message, buttons: buttons, icon: params.icon, link: link, status: params.status },
    });
  };
    /**
     * 点我达APP Native页面跳转
     *
     * @param {Runtime.DwdForwardToNativeData}
     */
  native.prototype.forwardToNative = function (params) {
    const _this = this;
    return new Promise((resolve, reject) => {
      _this.callHandler({
        name: 'forward',
        params: { topage: params.topage, type: params.type, params: params.params, extraMsg: params.extraMsg || '' },
        onSuccess: resolve,
        onFail: reject
      });
    });
  };
    /**
     * 点我达APP Native拍照并上传至OSS
     */
  native.prototype.takeAndUploadPicture = function (params) {
    const _this = this;
    const arg = params.photoMode ? {
      type: params.type,
      photoMode: params.photoMode
    } : {
      type: params.type
    };
        // 为啥子不直接用params ↑↑↑↑↑↑
    if (params.cameraType) {
      arg.cameraType = params.cameraType;
    }
    return new Promise((resolve, reject) => {
      _this.callHandler({
        name: 'takeAndUploadPicture',
        params: arg,
        onSuccess: resolve,
        onFail: reject
      });
    });
  };
  native.prototype.httpRequest = function (params) {
    const _this = this;
    return new Promise((resolve, reject) => {
      _this.callHandler({
        name: 'httpRequest',
        params: {
          requestParams: params.requestParams
        },
        onSuccess: resolve,
        onFail: reject
      });
    });
  };
  native.prototype.uploadBase64 = function (params) {
    const _this = this;
    return new Promise((resolve, reject) => {
      _this.callHandler({
        name: 'uploadBase64',
        params: {
          data: params.data
        },
        onSuccess: resolve,
        onFail: reject
      });
    });
  };
  native.prototype.setTitle = function (params) {
    this.callHandler({
      name: 'setHeaderTitle',
      params: { title: params.title }
    });
  };
    /**
     * 调用微信sdk支付功能
     */
  native.prototype.chooseWXPay = function () {
  };
    /**
     * 点我达商家APP下获取计费信息
     *
     * @param {Runtime.GetNativeDataParam} params
     * @returns {Promise}
     */
  native.prototype.getNativeData = function (params) {
    const _this = this;
    return new Promise((resolve, reject) => {
      _this.callHandler({
        name: 'getNativeData',
        params: { key: params.key },
        onSuccess: function (res) {
          resolve(res);
        }
      });
    });
  };

    /**
     * 点我达APP下webview监听消息
     *
     * @param {Runtime.onMessageParam} params
     * @returns {Promise}
     */
  native.prototype.onMessage = function (params) {
    const _this = this;
    return new Promise((resolve, reject) => {
      _this.callHandler({
        name: 'onMessage',
        params: params,
        onSuccess: resolve,
        onFail: reject
      });
    });
  };

    /**
     * 点我达APP下webview发送消息给别的webview
     *
     * @param {Runtime.postMessageParam} params
     * @returns {Promise}
     */
  native.prototype.postMessage = function (params) {
    const _this = this;
    return new Promise((resolve, reject) => {
      _this.callHandler({
        name: 'postMessage',
        params: params,
        onSuccess: resolve,
        onFail: reject
      });
    });
  };

    /**
     * 点我达APP下H5通知native某些事件
     *
     * @param {Runtime.notifyNativeParam} params
     * @returns {Promise}
     */
  native.prototype.notifyNative = function (params) {
    const _this = this;
    return new Promise((resolve, reject) => {
      _this.callHandler({
        name: 'notifyNative',
        params: params,
        onSuccess: resolve,
        onFail: reject
      });
    });
  };

    /**
     * 派件业务弹出保险弹框并打开QRCode扫码
     *
     * @returns {Promise}
     */
  native.prototype.openDialogThenScanQRCode = function () {
    const _this = this;
    return new Promise((resolve, reject) => {
      _this.callHandler({
        name: 'openDialogThenScanQRCode',
        onSuccess: resolve,
        onFail: reject
      });
    });
  };

    /**
     * 一键叫人刷新首页tab
     *
     * @returns {Promise}
     */
  native.prototype.refreshCapacityView = function (params) {
    const _this = this;
    return new Promise((resolve, reject) => {
      _this.callHandler({
        name: 'refreshCapacityView',
        params: params,
        onSuccess: resolve,
        onFail: reject
      });
    });
  };

    /**
     * 带提示步骤的拍照、上传
     * @function
     * @param {Runtime.takePhotoAndUploadParam} params
     * @description 相比较于 takeAndUploadPicture，增加了tips和拍照规范查看的步骤
     * @returns {Promise}
     * */
  native.prototype.takePhotoAndUploadWithTips = function (params) {
    const _this = this;
    return new Promise((resolve, reject) => {
      if (!params.tips) {
        params.tips = '平台将会根据面单照片进行审核，请确保照片真实清晰';
      }
      if (!params.buttonText) {
        params.buttonText = '查看货品拍摄规范';
      }
      if (!params.scene) {
        params.scene = 8;
      }
      if (!params.picType) {
        params.picType = 5;
      }
      if (params.type === undefined) {
        params.type = 0;
      }
      _this.callHandler({
        name: 'takePhotoAndUploadWithTips',
        params: { extraMsg: params },
        onSuccess: resolve,
        onFail: reject
      });
    });
  };

    /**
     * 是否支持微信支付
     */
  native.prototype.getSupportWXPay = function () {
    const _this = this;
    return new Promise((resolve, reject) => {
      _this.callHandler({
        name: 'getSupportWXPay',
        params: {},
        onSuccess: resolve,
        onFail: reject
      });
    });
  };

    /**
     * 微信支付
     */
  native.prototype.startWechatPay = function (params) {
    const _this = this;
    return new Promise((resolve, reject) => {
      _this.callHandler({
        name: 'startWechatPay',
        params: params,
        onSuccess: resolve,
        onFail: reject
      });
    });
  };
    /**
     * 支付宝支付
     */
  native.prototype.startAliPay = function (params) {
    const _this = this;
    return new Promise((resolve, reject) => {
      _this.callHandler({
        name: 'startAliPay',
        params: params,
        onSuccess: resolve,
        onFail: reject
      });
    });
  };
    /**
     * 支付宝新SDK支付
     */
  native.prototype.startAliPayUrl = function (params) {
    const _this = this;
    return new Promise((resolve, reject) => {
      _this.callHandler({
        name: 'startAliPayUrl',
        params: params,
        onSuccess: resolve,
        onFail: reject
      });
    });
  };
    /**
     * @description native 链接跳转方法
     * @param params url:native链接
     */
  native.prototype.dwdRoute = function (params) {
    this.callHandler({
      name: 'dwdRoute',
      params: params,
    });
  };
  return native;
}());
exports.native = native;
